<div>
    <div class="row chartbox-allignment property-dashboard-charts margin-top-10">
        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 flexchild">
          <div class="border-div box-height margin-bottom-20">
            <div class="d-flex filter-header-rt" >
              <h2 class="mainhead mr-auto">
                <span class="text">Marketing Metrics</span>
              </h2>
              <div *ngIf="IsPortfolio" class="d-flex">
                <div class="select-dropdown multiselectdesign multi-check-dropdown margin-right-10">
                  <mat-form-field  >
                    <mat-select placeholder="Select Properties"
                              [(ngModel)]="propertyIds"
                              (selectionChange)="redrawMarketingReport($event.value)"
                              multiple>
                              @if (propertyIds?.length > 1) {
                      <mat-select-trigger>
                        <span>{{ propertyIds?.length }} items selected</span>
                        </mat-select-trigger>
                        }

                      @for (property of portfolioProperties; track property.id) {
                        <mat-option [value]="property" class="multi-dropdown-item">
                          {{property.name}}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
                <label class="select">
                  <select class="form-control" #Marketing="ngModel" (change)="redrawMarketingReport($event)" [(ngModel)]="selectedItem">
                    <option *ngFor="let item of marketingList" [(ngValue)]="item.id">{{item.name}}</option>
                  </select>
                  <i></i>
                </label>
              </div>
              <div *ngIf="!IsPortfolio" class="select-dropdown multiselectdesign margin-right-15 multi-check-dropdown">
                <mat-form-field  >
                  <mat-select placeholder="Select Marketing"
                            [(ngModel)]="marketingIDs"
                            (selectionChange)="redrawMarketingReport($event.value)"
                            multiple>
                        @if (marketingIDs?.length > 1) {
                        <mat-select-trigger>
                          <span>{{ marketingIDs?.length }} items selected</span>
                          </mat-select-trigger>
                        }

                    @for (marketing of marketingList; track marketing.id) {
                      <mat-option [value]="marketing.id" class="multi-dropdown-item">
                        {{marketing.name}}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
              <mat-form-field class="select">
                <mat-select [(ngModel)]="period" 
                           (selectionChange)="periodChange()">
                  <mat-option [value]="3">3 Months</mat-option>
                  <mat-option [value]="6">6 Months</mat-option>
                  <mat-option [value]="12">1 Year</mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div *ngIf="!isFromPortfolio" id="LineMarketingReport"></div>
            <div *ngIf="isFromPortfolio" style="filter: blur(4px);
  -webkit-filter: blur(4px);" id="LineMarketingReport"></div>
          </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 flexchild">
            <app-property-offer-comparison  [propertyId]="propertyId" [isFromPortfolio]="isFromPortfolio"></app-property-offer-comparison>
        </div>
    </div>
    <div class="row chartbox-allignment property-dashboard-charts margin-bottom-0">
        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 flexchild">
          <div class="border-div box-height margin-bottom-20">
            <div class="d-flex filter-header-rt" style="align-items:normal;">
              <h2 class="mainhead mr-auto">
                <span class="text">Prospect Status</span>
              </h2>


            </div>
            <div *ngIf="!isFromPortfolio" id="BarProspectsStatus"></div>
            <div *ngIf="isFromPortfolio" style="filter: blur(4px);
  -webkit-filter: blur(4px);" id="BarProspectsStatus"></div>
          </div>
               
            </div>
        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 flexchild">
            <app-leads-conversion [propertyId]="propertyId" [isFromPortfolio]="isFromPortfolio"></app-leads-conversion>
        </div>
    </div>
</div>
